import { css } from '@emotion/css';

import { colors } from '@ajaibid/components';

export const styPaymentInfoWrapper = ({ isPremium, isPremiumTrial }) => css`
  border-radius: 12px;
  border: 1px solid ${colors.NEUTRAL_2};
  margin: ${isPremium || isPremiumTrial ? '16px' : '50px 16px 16px 16px'};
  padding: 16px;
`;

export const styPaymentAction = css`
  display: flex;
  flex-flow: row;
  justify-content: space-around;
`;

export const styPaymentTitle = css`
  font-weight: 800;
  font-size: 16px;
  margin-right: 4px;
`;

export const styPaymentAmount = css`
  font-weight: bold;
  font-size: 18px;
`;

export const styPaymentInfo = css`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  border-radius: 8px;
  background: ${colors.AJAIB_BLUE_1};
  margin: 16px 0;
  color: ${colors.AJAIB_BLUE_5};
  cursor: pointer;
`;

export const styPaymentSection = css`
  display: flex;
  align-items: center;
`;

export const styBalanceItem = css`
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  cursor: pointer;
  width: 71px;
`;

export const styBalanceAction = css`
  background: ${colors.AJAIB_BLUE_1};
  padding: 8px;
  border-radius: 8px;
  display: flex;
`;

export const styBalanceTitle = css`
  font-size: 12px;
  color: ${colors.AJAIB_BLUE_5};
  margin-top: 4px;
`;
